import { render } from "./Collectibles.vue?vue&type=template&id=0b2250f3&scoped=true"
import script from "./Collectibles.vue?vue&type=script&lang=js"
export * from "./Collectibles.vue?vue&type=script&lang=js"

import "./Collectibles.vue?vue&type=style&index=0&id=0b2250f3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b2250f3"]])

export default __exports__